 // Function to show/hide the dropdown content
 function toggleDropdown() {
    const dropdownContent = document.querySelector(".dropdown-content");
    const dropdownButton = document.querySelector(".dropbtn");
    dropdownContent.style.display =
      dropdownContent.style.display === "block" ? "none" : "block";
      if(dropdownContent.style.display ==="block"){
        dropdownButton.innerHTML = "Filter ausblenden:";
      }
      else{
        dropdownButton.innerHTML = "Filter anzeigen:";
      }
  }

  // Event listener to toggle the dropdown content when the dropdown button is clicked
  const dropdownButton = document.querySelector(".dropbtn");
  dropdownButton.addEventListener("click", toggleDropdown);

